export default __webpack_public_path__ + "static/media/new-ci-back-ejemplo.8662f5de.jpg";